import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { NgxSpinnerService } from 'ngx-spinner';
import * as reducers from '@nrwl/rx-user';
import { DisableSpinner } from '@nrwl/rx-user';
import { RxIconModule } from '@nrwl/rx-icon';

@Component({
  selector: 'rx-spinner',
  templateUrl: './rx-spinner.component.html',
  styleUrls: ['./rx-spinner.component.scss'],
  imports: [CommonModule, RxIconModule],
})
export class RxSpinnerComponent implements OnDestroy {
  private static activeSpinnerCount = 0;
  private static previousBodyOverflow = '';

  constructor(
    private spinner: NgxSpinnerService,
    private store: Store<any>,
    @Inject(DOCUMENT) private document: Document,
  ) {
    if (RxSpinnerComponent.activeSpinnerCount === 0) {
      RxSpinnerComponent.previousBodyOverflow = this.document.body.style.overflow;
      this.document.body.style.overflow = 'hidden';
    }
    RxSpinnerComponent.activeSpinnerCount += 1;

    this.store.pipe(select(reducers.getSpinnerStatus)).subscribe((res) => {
      if (res) {
        console.log('spinner on ');
        this.spinner.show();
        setTimeout(() => {
          /** spinner ends after 5 seconds */
          this.store.dispatch(new DisableSpinner());
          this.spinner.hide();
        }, 5000);
      } else {
        this.spinner.hide();
      }
    });
  }

  public ngOnDestroy(): void {
    RxSpinnerComponent.activeSpinnerCount -= 1;

    if (RxSpinnerComponent.activeSpinnerCount === 0) {
      this.document.body.style.overflow = RxSpinnerComponent.previousBodyOverflow;
    }
  }
}
